import React, { useEffect } from 'react';
import i18n from '../../i18n/config';
import { useSelector } from 'react-redux';
import { RootState } from '../../types/redux';
import { ODTContainerProps } from '../../types/props';
import { ICONS } from '../../constants/enums';

import AmountPurposeForm from '../../components/ODT/AmountPurposeForm';
import Alert from '../../components/Common/Alerts/Alert';

const AmountPurpose = ({ props }: { props: ODTContainerProps }) => {
  const { setTitle, setShowButtons } = props;
  const onDemandTransfer = useSelector((state: RootState) => state.onDemandTransfer);
  const { bankAccountFeeBanner } = onDemandTransfer;

  useEffect(() => {
    // Set title
    setTitle(i18n.t("PAGES.ODT.AMT_PURPOSE.TITLE"));
    // Hide parent component buttons to allow redux-form buttons to be displayed
    setShowButtons(false);
  }, []);

  return (
    <>
      {bankAccountFeeBanner &&
        <Alert
          alertClasses={"alert-info spacing-top-small flex-row align-items-center font-regular"}
          icon={ICONS.INFO}
          iconClasses={"spacing-right-tiny"}
          message={bankAccountFeeBanner}
          isHTML={false}
        />
      }
      <div className="max-w-360">
        <p className="bold navy-blue">{i18n.t("PAGES.ODT.AMT_PURPOSE.INSTRUCTIONS")}</p>
        <p className="marengo-grey">{i18n.t("PAGES.ODT.AMT_PURPOSE.EXAMPLE")}</p>
      </div>
      <AmountPurposeForm {...props} />
    </>
  );
}

export default AmountPurpose;